let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("94JcZ")).then(() => parcelRequire('e0VSJ'));